/* global I18n */
import React from 'react'
import PropTypes from 'prop-types'
import { draftEditPageUrl } from './helpers'
import { bundleDraftEditPageUrl } from './helpers'

const SUPPORTED_PRODUCT_TYPE = '3d_models'

const DraftNameCell = ({
  id,
  name,
  is_bundle = null,
  product_type = null,
}) => {
  const content = (
    <>
      <span className="my-drafts__item-thumbnail-wrapper my-drafts__item-thumbnail-wrapper-thumbnail" />
      <div className="details my-products__item-details" style={{ maxWidth: '80%' }}>
        <h5 className="name my-products__item-details">{ name }</h5>
      </div>
    </>
  )

  if (product_type && product_type !== SUPPORTED_PRODUCT_TYPE) {
    return (
      <div style={{ maxWidth: '100%' }} title={I18n.t('turbosquid.products.non_3d_tooltip')}>
        {content}
      </div>
    )
  }

  return (
    <div style={{ maxWidth: '100%' }}>
      <a href={is_bundle === 1 ? bundleDraftEditPageUrl(id) : draftEditPageUrl(id)} rel="noopener noreferrer" title={name}>
        {content}
      </a>
    </div>
  )
}

DraftNameCell.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  product_type: PropTypes.string,
  is_bundle: PropTypes.number,
}

export default DraftNameCell
